import styled from 'styled-components';
import { palette, theme } from 'styled-tools';

import { FontSizes, fontWeight, FontWeights, minWidth, Text } from '@calm-web/design-system';

import GridWrapper from '@/components/ui/GridWrapper';

export const Wrapper = styled.section`
	background: ${palette('gradientBrightPurple')};
	color: ${palette('white')};
	padding: 40px 0;
	text-align: center;

	${minWidth('tablet')} {
		padding: 80px 0;
	}
`;

export const Heading = styled(Text).attrs({
	weight: FontWeights.Regular,
	size: FontSizes.xl,
	lineHeight: FontSizes.xl,
	el: 'h2',
	styleAs: 'h2',
})`
	grid-column: 1 / 4;
	margin-top: 0;
	margin-bottom: 16px;

	${minWidth('tablet')} {
		font-size: 49.5px;
	}
`;

export const JoinStat = styled(Text).attrs({
	noMargin: true,
	size: FontSizes.base,
	lineHeight: FontSizes.xl,
	weight: FontWeights.Regular,
	el: 'p',
	styleAs: 'h3',
})`
	grid-column: 1 / 4;

	${minWidth('tablet')} {
		font-size: 22.5px;
	}
`;

export const StarsWrapper = styled.div`
	grid-column: 1 / 4;
	margin: 16px 0 40px;
`;

export const TestimonialItems = styled.div`
	display: none;
	grid-column: 1 / 4;
	margin-bottom: 40px;
	text-align: center;

	${minWidth('tablet')} {
		display: block;
	}
`;

export const TestimonialItemsGrid = styled(GridWrapper)`
	margin: 0;
`;

export const TestimonialItem = styled.div<{
	isActive?: boolean;
}>`
	background: ${palette('white')};
	border-radius: 16px;
	box-shadow: 0px 6px 16px rgba(0, 0, 0, 0.08);
	color: ${palette('gray8')};
	display: flex;
	flex-direction: column;
	padding: 24px 16px 16px 12px;
	position: relative;
	text-align: left;
	transform: translateX(${p => (p.isActive ? '0' : '-16px')});
	width: calc(100% - 32px);

	${minWidth('tablet')} {
		margin: 0;
		padding: 24px 24px 24px 20px;
		width: 100%;
	}
`;

export const MobileTestimonialItems = styled.div`
	display: block;
	grid-column: 1 / 4;
	text-align: center;

	${minWidth('tablet')} {
		display: none;
	}

	& li:last-of-type {
		${TestimonialItem} {
			width: 100%;
		}
	}
`;

export const QuoteIcon = styled.div`
	color: ${palette('blue3')};
	font-size: 49.5px;
	${fontWeight(FontWeights.Regular)};
	left: 16px;
	position: absolute;
	top: 8px;
`;

export const TestimonialQuote = styled.blockquote`
	margin-bottom: 24px;
	margin-left: 28px;

	& strong {
		${fontWeight(FontWeights.Demi)};
	}
`;

export const AuthorRow = styled.div`
	display: flex;
	margin-top: auto;
`;

export const AuthorName = styled.p`
	color: ${palette('gray8')};
	${fontWeight(FontWeights.Medium)};
`;

export const AuthorThumbnail = styled.div`
	flex: 0 0 48px;
	height: 48px;
	margin-right: 8px;
	width: 48px;
`;

export const MemberSince = styled.div`
	color: ${palette('gray6')};
	font-size: 13.5px;
	${fontWeight(FontWeights.Medium)};
`;

export const ButtonWrapper = styled.div`
	grid-column: 1 / 4;
	margin: 48px auto 0;
	width: 100%;

	${minWidth('tablet')} {
		width: 50%;
	}

	${minWidth('desktop')} {
		grid-column: 2 / 3;
		width: 100%;
	}
`;

export const Nav = styled.nav`
	align-items: center;
	display: flex;
	justify-content: center;
	margin-top: 40px;
`;

export const Arrow = styled.div`
	height: 40px;
	width: 30px;
	cursor: pointer;

	& path {
		fill: ${palette('white')};
		stroke: ${palette('white')};
		stroke-linecap: round;
		stroke-width: 6;
	}

	&:last-of-type {
		transform: rotate(180deg);
	}
`;

export const NavDot = styled.div<{
	isActive: boolean;
}>`
	background: ${palette('white')};
	border-radius: 50%;
	cursor: pointer;
	height: 8px;
	margin: 0 6px;
	opacity: ${(p): number => (p.isActive ? 1 : 0.33)};
	transition: opacity ${theme('animation.transition')};
	width: 8px;

	&:first-of-type {
		margin-left: 32px;
	}

	&:last-of-type {
		margin-right: 32px;
	}
`;
